module.exports = __webpack_public_path__ + "img/high.1aa4042e.png";